import { Component, OnInit, Input } from '@angular/core';
import { take } from 'rxjs/operators';
import { PicklistService } from '../../../services/picklist/picklist.service';
import { SchemaField, Document, PicklistValue } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'app-multi-picklist-column',
    templateUrl: './multi-picklist-column.component.html',
    styleUrls: ['./multi-picklist-column.component.scss'],
    standalone: false
})
export class MultiPicklistColumnComponent implements OnInit, DynamicColumn {
  _field: SchemaField;
  _document: Document;


  @Input() set field(value: SchemaField) {
    this._field = value;
    if (!!this._document) {
      this.setFieldValue();
    }
  }
  @Input() set document(value: Document) {
    this._document = value;
    if (!!this._field) {
      this.setFieldValue();
    }
  }

  fieldValue: string;

  constructor(private picklistService: PicklistService) {}

  ngOnInit(): void { }

  private setFieldValue(): void {
    const value = this._document?.[this._field.systemName];

    const values = [];

    this.picklistService.getPicklistValues(this._field)
    .pipe(take(1))
    .subscribe(picklistValues => {
      value?.map(id => {
        const selectedPickListItem = picklistValues?.find(p => p.uId === id) as PicklistValue;
        if (selectedPickListItem) {
          values.push(selectedPickListItem.value);
        }
      });
      this.fieldValue = values.join(', ');
    });
    }
  }

